var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChallengesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4755_49851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 14.1667C8.1584 14.1667 6.66602 16.0322 6.66602 18.3333H13.3327C13.3327 16.0322 11.8403 14.1667 9.99935 14.1667Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4173 4.16667H18.334L18.1353 5.55747C17.916 7.09251 17.8064 7.86004 17.5015 8.52226C17.1729 9.23592 16.6807 9.86209 16.065 10.3501C15.4936 10.8028 14.7737 11.0908 13.334 11.6667",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58268 4.16667H1.66602L1.8647 5.55747C2.08399 7.09251 2.19364 7.86004 2.49853 8.52226C2.82711 9.23592 3.31924 9.86209 3.93503 10.3501C4.50643 10.8028 5.22629 11.0908 6.66602 11.6667",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 14.1667C7.13076 14.1667 4.78203 9.01542 4.59604 2.50079C4.58291 2.04074 4.95727 1.66667 5.41751 1.66667H14.5842C15.0444 1.66667 15.4188 2.04074 15.4057 2.50078C15.2197 9.01542 12.8709 14.1667 10.0008 14.1667Z",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4755_49851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesIcon);
export default __webpack_public_path__ + "static/media/challenges-icon.1b3b2a29e2413acce58fa7490fae3b67.svg";
export { ForwardRef as ReactComponent };